import React from 'react';
import { Home, User as UserIcon, Globe, Plus, LayoutGrid, Layers } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const MobileBottomNav = ({ profile }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleGenerateClick = () => {
    navigate('/ai');
    if (location.pathname === '/ai') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const isHome = location.pathname === '/ai' || location.pathname === '/';
  const isGallery = location.pathname === '/gallery';
  const isCommunity = location.pathname === '/community';
  const isProfile = location.pathname.startsWith('/settings') || location.pathname === '/history';

  // Return the new pill-style bottom nav
  return (
    <div className="mobile-only-input" style={{
      position: 'fixed',
      bottom: '30px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'none',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: '#111',
      padding: '8px 12px',
      borderRadius: '99px',
      boxShadow: '0 20px 40px rgba(0,0,0,0.5), inset 0 1px 1px rgba(255,255,255,0.1)',
      zIndex: 9999,
      border: '1px solid rgba(255,255,255,0.05)',
      width: 'max-content'
    }}>
      
      {/* Dashboard */}
      <Link 
        to="/ai"
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: isHome ? 'rgba(255,255,255,0.1)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: isHome ? '#a3e635' : '#666',
          transition: 'all 0.3s ease'
        }}
      >
        <Layers size={20} strokeWidth={2.5} />
      </Link>

      {/* Gallery */}
      <Link 
        to="/gallery"
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: isGallery ? 'rgba(255,255,255,0.1)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: isGallery ? '#a3e635' : '#666',
          transition: 'all 0.3s ease'
        }}
      >
        <LayoutGrid size={20} strokeWidth={2.5} />
      </Link>

      {/* Community */}
      <Link 
        to="/community"
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: isCommunity ? 'rgba(255,255,255,0.1)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: isCommunity ? '#a3e635' : '#666',
          transition: 'all 0.3s ease'
        }}
      >
        <Globe size={20} strokeWidth={2.5} />
      </Link>

      {/* Profile */}
      <Link 
        to="/settings"
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: isProfile ? 'rgba(255,255,255,0.1)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: isProfile ? '#a3e635' : '#666',
          transition: 'all 0.3s ease'
        }}
      >
        <UserIcon size={20} strokeWidth={2.5} />
      </Link>
      
    </div>
  );
};

export default MobileBottomNav;
